import React from 'react';
import { View, Text, TouchableOpacity } from 'react-native';
import { DESKTOP_STYLES, DESKTOP_COLORS } from '@/constants/admin';
import { SVG_COMPONENTS } from '@/assets/admin';
import { IPaginationModel } from '@/types/admin/dataTable';
import { styles } from './DesktopDataTableStyles';

interface DesktopPaginationProps {
  dataCount: number;
  paginationModel: IPaginationModel;
  onPaginationChange?: (paginationModel: IPaginationModel) => void;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  onNextPage?: () => void;
  onPreviousPage?: () => void;
}

export const DesktopPagination: React.FC<DesktopPaginationProps> = ({
  dataCount,
  paginationModel,
  onPaginationChange,
  hasNextPage,
  hasPreviousPage,
  onNextPage,
  onPreviousPage,
}) => {
  const startIndex = paginationModel.page * paginationModel.pageSize + 1;
  const endIndex = Math.min((paginationModel.page + 1) * paginationModel.pageSize, dataCount);
  const pageSizeOptions = [25, 50, 100];

  const changePageSize = (size: number) => {
    if (size === paginationModel.pageSize) return;
    onPaginationChange?.({ ...paginationModel, page: 0, pageSize: size });
  };

  return (
    <View style={styles.paginationContainer}>
      <View style={styles.paginationLeft}>
        <Text style={[styles.paginationText, DESKTOP_STYLES.secondaryText]}>
          Showing {startIndex}–{endIndex} of {dataCount} results
        </Text>
        <View style={styles.rowsPerPageContainer}>
          <Text style={[styles.rowsPerPageLabel, DESKTOP_STYLES.secondaryText]}>Rows per page:</Text>
          <View style={styles.rowsPerPageOptions}>
            {pageSizeOptions.map((opt) => (
              <TouchableOpacity
                key={`rpp-${opt}`}
                style={[styles.rowsPerPageOption, opt === paginationModel.pageSize ? styles.rowsPerPageOptionSelected : undefined]}
                onPress={() => changePageSize(opt)}
              >
                <Text style={[styles.rowsPerPageOptionText, opt === paginationModel.pageSize ? styles.rowsPerPageOptionTextSelected : DESKTOP_STYLES.secondaryText]}>
                  {opt}
                </Text>
              </TouchableOpacity>
            ))}
          </View>
        </View>
      </View>
      <View style={styles.paginationButtons}>
        <TouchableOpacity
          style={[styles.paginationButton, !hasPreviousPage && styles.paginationButtonDisabled]}
          onPress={onPreviousPage}
          disabled={!hasPreviousPage}
        >
          <SVG_COMPONENTS.CHEVRON_LEFT width={16} height={16} color={!hasPreviousPage ? DESKTOP_COLORS.TABLE.TEXT_SECONDARY : DESKTOP_COLORS.TABLE.TEXT} />
          <Text style={[styles.paginationButtonText, !hasPreviousPage ? styles.paginationButtonTextDisabled : styles.paginationButtonTextEnabled]}>Previous</Text>
        </TouchableOpacity>
        <TouchableOpacity
          style={[styles.paginationButton, !hasNextPage && styles.paginationButtonDisabled]}
          onPress={onNextPage}
          disabled={!hasNextPage}
        >
          <Text style={[styles.paginationButtonText, !hasNextPage ? styles.paginationButtonTextDisabled : styles.paginationButtonTextEnabled]}>Next</Text>
          <SVG_COMPONENTS.CHEVRON_RIGHT width={16} height={16} color={!hasNextPage ? DESKTOP_COLORS.TABLE.TEXT_SECONDARY : DESKTOP_COLORS.TABLE.TEXT} />
        </TouchableOpacity>
      </View>
    </View>
  );
};


